import { Provider } from "react-redux";
import store from "./redux/store/store";
import { createRoot } from "react-dom/client";
import { app } from "@microsoft/teams-js";
import App from "./App";
import { waitForTeamsContext, applyTeamsContext } from "./utils/teamsContextBootstrap";
import { initializeFluentIconsOnce } from "./utils/initializeFluentIconsOnce";

const rootEl = document.getElementById("root");
const root = createRoot(rootEl);
initializeFluentIconsOnce();

function renderApp() {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}

app
  .initialize()
  .then(() => waitForTeamsContext())
  .then((context) => {
    applyTeamsContext(context, store);
    renderApp();
  })
  .catch((err) => {
    console.warn("[AddoShareTeams] Teams context unavailable (open app in Microsoft Teams)", err);
    renderApp();
  });